<script lang="ts">
  import type { Diligence } from "../../../../Model/Diligence";
  import { usersService } from "../../../../services";
  import { Input, Label, TabContent, TabPane } from "sveltestrap";
  import ParamSelect from "../../../ParamSelect.svelte";
  import { getContext, select_value } from "svelte/internal";
  import type { User } from "../../../../Model/User"
  import { dateInputFormatter, dateTimeInputFormatter } from "../../../../services/Functions";
  import type { Writable } from "svelte/store";
  import PoliceManifestationFinishForm from "../../Global/PoliceManifestationFinishForm.svelte";
  import type { PoliceManifestationGeneral } from "../../../../Model/PoliceManifestationGeneral";

  export let diligence: Diligence;

  const policeManifestationGeneral: Writable<PoliceManifestationGeneral> = getContext('policeManifestationGeneral');
  

  let users: User[];
  
  let offset: number = 0;
  let limit: number = 179;
  let searchFilter = null;


  let arrivalTime: string;
  let hourCommunicate: string;
  let referralDate: string;
  let dateCheckEthilometer: string;

  $: loadPoliceManifestationGeneral(diligence);

  $: loadUsers();
  async function loadUsers() {
    let opts = {
      offset: offset,
      limit: limit,
      filters: {
        search: searchFilter,
      },
    };
    try {
      users = await usersService.findUsers(opts);
    } catch (err) {}
  }

  async function loadPoliceManifestationGeneral(diligence) {
    if ($policeManifestationGeneral) {
      referralDate = dateInputFormatter($policeManifestationGeneral.referralDate);
    }
  }

  // async function save() {
  //   try {
  //     await policeManifestationGeneralService.savePoliceManifestationTraffic(policeManifestationGeneral)
  //     success("Datos guardados con exito");
  //   } catch (err) {
  //     error("Comprueba los campos");
  //   }
  // }

  function onHandleChange() {
    policeManifestationGeneral.update(manifest => {
      manifest.referralDate = new Date(referralDate + "T00:00:00.000Z");
      return manifest;
    })
  }


  function getUser(): string {
    let user: User = JSON.parse(localStorage.getItem("current_user"));
    return user.id;
  }

</script>

<!-- eyeInspectionResult: boolean,
samplesInvolved: boolean,
sampleTypes: string,
                            weaponsIntervene: boolean,
                            typesWeapons: string,
armsWithdrawalProcedure: boolean,
interestingData: string,

transferHealthCenter: boolean,
accompanyAddressEffects: boolean,
accompanyFamilyHome: boolean,
transferReceptionCenter: boolean,

observations: string,

referralDate: Date,
numFoliosRemission: number | null,
numReferralMinutes: number | null,
independentMinutes: string,
numCitations: number | null,
citations: string,
bodyTransfer: number | null, -->




{#if diligence }
<div class="mt-3">
  <TabContent>
    <TabPane tabId="ManiPol" tab="Datos" active>
      <PoliceManifestationFinishForm {diligence} />
    </TabPane>
    {#if $policeManifestationGeneral}

      <TabPane tabId="ManiPolData" tab="Inspección">
        
        <div class="row mt-3">
          <div class="col-12 col-sm-6 mb-3">
            <Label for="inspeccion ocular"> Inspección ocular </Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.ocularInspection ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.ocularInspection = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-6 mb-2">
            <Label>Resultado inspección ocular</Label>
            <Input type="text" bind:value={$policeManifestationGeneral.eyeInspectionResult} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="matricula"> Intervienen Muestras </Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.samplesInvolved ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.samplesInvolved = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-8 mb-3">
            <Label for="marca">Tipos de muestras</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationGeneral.sampleTypes}
            />
          </div>

          <div class="col-12 col-sm-6 mb-3">
            <Label for="matricula"> Armas </Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.weaponsIntervene ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.weaponsIntervene = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <Label for="matricula"> Tramite de retirada de Armas </Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.armsWithdrawalProcedure ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.armsWithdrawalProcedure = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
          <div class="col-12 mb-3">
            <Label for="marca">Tipos de Armas</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationGeneral.typesWeapons}
            />
          </div>


          <div class="col-12 mb-3">
            <Label for="marca">Datos de Interés</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationGeneral.interestingData}
            />
          </div>

          <div class="col-12 mb-3">
            <Label for="modelo">Observaciones</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={$policeManifestationGeneral.observations}
            />
          </div>

        </div>
      </TabPane>
      <TabPane tabId="3" tab="Traslados">
        <div class="row mt-3">
          <div class="col-12 col-sm-4 mb-3">
            <Label for="marca">Traslado Médico</Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.transferHealthCenter ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.transferHealthCenter = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="marca">Acompañar a Domicilio</Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.accompanyAddressEffects ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.accompanyAddressEffects = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="marca">Traslado a Casa de un Familiar</Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.accompanyFamilyHome ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.accompanyFamilyHome = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="marca">Centro de acogida</Label>
            <Input
              type="select"
              id="openJudgmentAggressor"
              value={$policeManifestationGeneral.transferReceptionCenter ? 1 : 0}
              on:change={(event) => {
                $policeManifestationGeneral.transferReceptionCenter = Boolean(
                  select_value(event.target)
                );
              }}
              >
              <option value={1}>Si</option>
              <option value={0}>No</option>
            </Input>
          </div>
        </div>


      </TabPane>

      <TabPane tabId="AboPol" tab="Remisión">
        <div class="row mt-3 mb-3">
          <!-- <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Núm. de actas remisión</Label>
            <Input type="number" id="matricula" bind:value={$policeManifestationGeneral.numActaRemission} />
          </div> -->
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Núm. de folios remisión</Label>
            <Input type="number" id="matricula" bind:value={$policeManifestationGeneral.numFoliosRemission} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Fecha remisión</Label>
            <Input type="date" id="matricula" 
            on:change={onHandleChange}
            bind:value={referralDate} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Acta independizada</Label>
            <Input type="text" id="matricula" bind:value={$policeManifestationGeneral.independentMinutes} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Citaciones</Label>
            <Input type="text" id="matricula" bind:value={$policeManifestationGeneral.citations} />
          </div>
          <div class="col-12 col-sm-4 mb-3">
            <Label for="validezInspeccion">Cuerpo traspaso</Label>
            <ParamSelect
              bind:paramSelectId={$policeManifestationGeneral.bodyTransfer}
              paramType="courts"
              nothing={true}
            />
          </div>
        </div>
      </TabPane>
    {/if}

  </TabContent>



  

</div>

{/if}
